<template>
  <div class="calculator">
    <div class="calculator__item-from">
      <CalculatorInput
        :input="cryptoAmount"
        :currencies="cryptoCurrencyList"
        :label="$t('calculator.form.from-label')"
        :is-loading="isLoading && !isSelectedAmountCrypto"
        @input-change="handleCryptoAmountChange($event)"
        @option-change="handleCryptoChange($event)"
        @option-is-open="loadCryptoCurrencies()"
        data-testid="cryptofield"
      />
    </div>
    <div class="calculator__item-to">
      <CalculatorInput
        :input="fiatAmount"
        :currencies="availableFiatCurrencies"
        :label="$t('calculator.form.to-label')"
        :is-loading="isLoading && isSelectedAmountCrypto"
        @input-change="handleFiatAmountChange($event)"
        @option-change="handleFiatChange($event)"
        @option-is-open="loadFiatCurrencies()"
        data-testid="fiatfield"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CalculatorInput from '@kano/components/Calculator/CalculatorInput.vue';
import { CalculatorAmount } from '@kano/models/calculator/calculatorAmount';
import { useCalculatorForm } from '@/composables/useCalculatorForm';

const {
  cryptoAmount,
  fiatAmount,
  cryptoCurrencyList,
  availableFiatCurrencies,
  isLoading,
  isSelectedAmountCrypto,
  handleCryptoAmountChange,
  handleFiatAmountChange,
  handleCryptoChange,
  handleFiatChange,
  loadCryptoCurrencies,
  loadFiatCurrencies,
} = useCalculatorForm(CalculatorAmount);
</script>
